const MeasureUnit = {

    // FIELDS
    "name": "Name",
    "description": "Description",
    "unit_type": "Unit Type",
    "search": "Search",

    // PAGE HEADER
    "measurement_unit": "Measurement Unit",

    // ERROR
    "error_name": "Enter Name",
    "error_desc": "Enter Description",
    "error_unitType": "Select Unit Type",

    // TABLE HEADER
    "table_name": 'NAME',
    "table_description": "DESCRIPTION",
    "table_unit_type": "UNIT TYPE",
}

export default MeasureUnit;
